export default __webpack_public_path__ + "static/media/sahan.19907638.png";